import { Link } from "react-router-dom";
import styled from "styled-components";
import IProject from "../../../common/interfaces/IProject";
import Placeholder from "assets/project_post_placeholder.png";
import themeProps from "theme/themes";
import { useTranslation } from "react-i18next";
import { flags } from "utils/flags";
import { formatDate } from "utils/time";

interface ProjectPostProps {
  project: IProject;
}

const Wrapper = styled(Link)`
  border: 1px solid #b2b2b2;
  border-radius: 20px;
  max-height: 200px;
  position: relative;
  display: flex;
  text-decoration: none;
  color: #080808;

  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

const Right = styled.div`
  width: 75%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
`;

const Left = styled.div`
  width: 25%;
  box-sizing: border-box;
`;

const Row = styled.div`
  margin-bottom: 20px;
  display: flex;
`;

const Title = styled.h2``;

const CreatedAt = styled.p`
  font-weight: 500;
  font-size: 1.1rem;
  align-self: center;
  margin-left: auto;
`;

const Description = styled.p`
  font-size: 1.2rem;
  width: 75%;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const PicturePlaceholder = styled.img`
  width: 100%;
  height: 100%;
`;

const Info = styled.div`
  color: #fff;
  background-color: ${(props: themeProps) => props.theme.main.primary};
  border-radius: 20px;
  padding: 0 16px;
  margin-right: 12px;
  display: flex;
  height: 20px;
  align-items: center;
  white-space: nowrap;
`;

const Language = styled.img`
  width: 1.2rem;
  &:not(:last-child) {
    margin-right: 10px;
  }
`;

const ProjectPost = ({ project }: ProjectPostProps) => {
  const { t } = useTranslation("interests");
  const createdAt = formatDate(project.createdAt);

  return (
    <Wrapper to={`/explore/${project._id}`}>
      <Left>
        <PicturePlaceholder src={Placeholder} />
      </Left>
      <Right>
        <Row>
          <Title>{project.title}</Title>
          <CreatedAt>{createdAt}</CreatedAt>
        </Row>
        <Row>
          <Description>{project.description}</Description>
        </Row>
        <Row style={{ marginBottom: 0, marginTop: "auto" }}>
          {project.categories.length > 0 &&
            project.categories.map((category) => (
              <Info key={category}>{t(category)}</Info>
            ))}
          {project.languages.length > 0 && (
            <Info style={{ padding: "0px 16px" }}>
              {project.languages.map((language) => {
                return <Language key={language} src={flags[language]} />;
              })}
            </Info>
          )}
          {project.startDate && (
            <Info>
              {project.startDate}{" "}
              {project.dueDate ? `- ${project.dueDate}` : null}
            </Info>
          )}
        </Row>
      </Right>
    </Wrapper>
  );
};

export default ProjectPost;
